import React from 'react'

export default function CircularProgress({ progress = 0 }) {
    const clamped = Math.min(100, Math.max(0, Math.round(progress)))
    const circumference = 2 * Math.PI * 45
    const strokeDashoffset = circumference - (clamped / 100) * circumference

    return (
        <div className="relative w-32 h-32">
            <svg className="w-32 h-32 transform -rotate-90" viewBox="0 0 100 100">
                <circle
                    cx="50" cy="50" r="45"
                    stroke="currentColor" strokeWidth="6" fill="none"
                    className="text-gray-300"
                />
                <circle
                    cx="50" cy="50" r="45"
                    stroke="currentColor" strokeWidth="6" fill="none"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    className="text-iavisus-100 transition-all duration-300 ease-in-out"
                />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-base font-bold text-iavisus-100">{clamped}%</span>
            </div>
        </div>
    )
}
